<template>
  <div>
    <form role="form" @submit.prevent="onSubmitForm()">
    <h6 class="mb-0">{{ titlePage }}</h6>
    <p class="mb-0 text-sm">{{ subtitlePage }}</p>
    <hr class="my-3 horizontal dark" />
    
    <div class="row mb-3" v-for="(item, key) in record.pricing_models" :key="key">
      <div class="col-12">
        <div class="row"> 
          <div class="col-sm-4">
            <div class="form-group">
              <label for="serviceName" class="form-label">Product Name</label>
              <input id="serviceName" type="text" class="form-control" v-model="record.service_name" required/>
            </div>          
          </div>            
          <div class="col-3">
            <label for="basePrice" class="form-label">Price</label>
            <div class="input-group">
              
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">Rp</span>
              </div>
              <input id="basePrice" type="number" class="form-control" v-model="item.base_price" required min="0" style="padding: 0.5rem 0.75rem;border-right:1px solid #d2d6da !important"/>
            </div>          
          </div>          
          <div class="col-5">
            <div class="form-group">
              <label for="trading_image_url" class="form-label">Image Url</label>
              <input id="trading_image_url" type="text" class="form-control" v-model="record.trading_info.image_url" required/>
            </div>          
          </div>         
        </div>   
        <div class="row">
          <div class="col-12 col-sm-12">
            <div class="form-group">
              <label for="description" class="form-label">Description</label>
              <quill-editor theme="snow" :options="options" v-model:content="record.description" contentType="html"></quill-editor>

            </div>          
          </div>
        </div>
      </div>               
    </div>

    <div class="mt-4 d-flex justify-content-end">
      <a class="m-0 btn btn-light" href="/pricings/indicators">
        Cancel
    </a>
      <button
          type="submit"
          name="button"
          class="m-0 btn bg-gradient-success ms-2"
      >
          {{ submitButtonName }}
      </button>
    </div>
  </form>
  </div>
</template>

<script>
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';

  export default {
    data() {
      return {
        unitTypes: ['month', 'year'],
        record: {
          trading_info: {image_url: '', target_url: ''},
          pricing_models: [{hint: {id: '', en: ''}, label: {id: '', en: ''}, description: {id: '', en: ''}}]
        },
      };
    },
    setup: () => {
    const options = {modules: {toolbar: false}}
    return { options }
  },
    components: {
      QuillEditor
    },
    methods: {
      onSubmitForm() {
        this.onSubmit(this.record)
      },
      onClickAddPricing(){
        this.record.pricing_models.push({hint: {id: '', en: ''}, label: {id: '', en: ''}, description: {id: '', en: ''}})
      },
      onClickRemovePricing(key){
        this.record.pricing_models.splice(key, 1)
      }

    },
    props: {
        titlePage: String,
        subtitlePage: String,
        submitButtonName: String,
        onSubmit: { type: Function },
        toggleModal: { type: Function },
        recordProps: { type: Object }
    },
    watch: {
        recordProps: function (newVal, oldVal) { // watch it
        console.log('Prop changed: ', newVal, ' | was: ', oldVal)
        this.record = newVal
        }
    },
    mounted() {
    
    },
  }
  </script>
<style>
.ql-container.ql-snow {
  width: 100%;
  min-height: 100px;
  border-radius: 8px;
}
</style>
  